module.exports = __webpack_public_path__ + "img/bb.9873885f.svg";